import { gql } from "@apollo/client";

export const createKeywordGroup = gql`
  mutation CreateKeywordGroup($input: KeywordGroupInput!) {
    createKeywordGroup(input: $input) {
      id
      name
      slug
      imageUrl
      type
      category
      keywords
      keywordsGroupIds
      deleted
      metadata
    }
  }
`;
